'use strict';
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = __importDefault(require('react'));
const rc_utils_1 = require('@hangar31/rc-utils');
const form_1 = require('../../contexts/form');
const useChangeHandler_1 = __importDefault(
  require('../../hooks/useChangeHandler')
);
const _helpers_1 = require('./_helpers');
function Input(_a) {
  var {
      children,
      elementType = 'input',
      name,
      onFocusOut,
      transform = value => value,
      value,
    } = _a,
    props = __rest(_a, [
      'children',
      'elementType',
      'name',
      'onFocusOut',
      'value',
      'transform',
    ]);
  const handleOnChange = (0, useChangeHandler_1.default)(transform);
  const { changedData, fields } = (0, form_1.useInternalForm)();
  const Element = elementType;
  const onBlur = e => {
    const isValid = (0, _helpers_1.checkValidity)(e);
    if (!isValid) return;
    if (onFocusOut) onFocusOut(changedData, e);
  };
  const onChange = e => {
    handleOnChange(e);
    if (props.type === 'checkbox' || props.type === 'radio')
      (0, _helpers_1.checkValidity)(e);
  };
  return react_1.default.createElement(
    Element,
    Object.assign(
      {
        'aria-required': !!props.required,
        defaultChecked:
          value !== undefined
            ? (0, rc_utils_1.getByPath)(fields || {}, name) === value
            : (0, rc_utils_1.getByPath)(fields || {}, name),
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        value:
          value !== undefined
            ? value
            : (0, rc_utils_1.getByPath)(fields || {}, name) || '',
      },
      props
    ),
    children
  );
}
exports.default = Input;
//# sourceMappingURL=BaseInput.js.map
